import { init } from '@mtfe/metric'

const { directive } = init({
  // mode: 'simple' | 'normal' | 'strict' | 'pgy', // 观察者模式，必填。默认为normal，模式的具体含义请参考: https://km.sankuai.com/page/1218948426#id-1.2.3%E6%A8%A1%E5%BC%8F%E6%8F%90%E4%BE%9B，pgy模式等价于normal，但是不开启pv的KNB监听功能
  finBiz: 'pay', // 业务代码，选填。建议填写，作为埋点参数上报
  // category: 'xxxx', // 新通道名称，选填。建议双通道上报场景填写，SDK会根据点id命名规范匹配新通道，未匹配到则使用meta中配置的老通道
  // cid: '', // 当前页面cid，选填。建议填写避免埋点漂移问题，若不填写则使用灵犀默认的cid关联规则
  // 埋点参数过滤器，必填。默认为{}，为每种类型的埋点增加filter，可以用于上报统一的公共参数
  filter: {
    mv: (v, o) => ({
      custom: v || {},
      options: o,
    }),
  },
})

const directiveProxy = {
  mc: {
    mounted: directive.mc.bind,
    updated: directive.mc.update,
  },
  mv: {
    mounted: directive.mv.bind,
    updated: directive.mv.update,
    unmounted: directive.mv.unbind,
  },
  pv: {
    mounted: directive.pv.bind,
    updated: directive.pv.update,
    unmounted: directive.pv.unbind,
  },
}
// 通过Vue局部指令方式注册
export default directiveProxy
